import React, { useMemo, useState } from 'react';

const OIKOTIE_BANNER_PROD_URL = `https://recommendations.asunnot.oikotie.fi/tori-aurora-front-page.html`;
export function useItemsWithOikotieAdPosition(
    adItems: React.ReactNode[],
    isFrontPage: boolean,
    adPosition: number = 10,
) {
    const [shouldHideIframe, setShouldHideIframe] = useState(true);
    const iframeRef = React.useRef<HTMLIFrameElement>(null);

    function handleLoad() {
        setShouldHideIframe(false);
    }
    const handleIframeError = () => {
        setShouldHideIframe(true);
    };

    return useMemo(() => {
        return adItems.map((adItem, index) => {
            if (index === adPosition && isFrontPage) {
                return (
                    <React.Fragment key={`ad-item-${index}`}>
                        <iframe
                            ref={iframeRef}
                            src={OIKOTIE_BANNER_PROD_URL}
                            className={`relative isolate recommendation-ad card card--cardShadow s-bg ${
                                shouldHideIframe ? 'hidden' : ''
                            }`}
                            width="100%"
                            height="100%"
                            onLoad={handleLoad}
                            onError={handleIframeError}
                        />
                        {adItem}
                    </React.Fragment>
                );
            }
            return adItem;
        });
    }, [adItems, adPosition, isFrontPage, shouldHideIframe]);
}
